export const QUOTE_PRODUCT_ID = 0;

export const NLP_PRODUCT_ID = 153;
